import React from 'react';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';
import { Container } from 'reactstrap';

import AppMeta from 'components/App/Meta';
import AppBreadcrumb from 'components/App/Breadcrumb';
import Loading from 'components/App/Loading';

import { LOCATIONS } from 'constants/index';
import INITIAL_VALUE from 'constants/initialValue';

import NearLocationList from './NearLocationList';

import styles from './NearLocation.module.scss';

function NearLocation(props) {
  const {
    isLoadingGetSetting,
    isLoadingGetPlaceDetail,

    placeDetail,

    actionGetPlaceDetail,
    actionResetPlaceDetail,
  } = props;

  const location = useLocation();
  const placeId = new URLSearchParams(location.search).get('place');

  const breadcrumbList = [
    {
      name: 'Chỗ nghỉ',
      isActive: false,
      link: `${LOCATIONS.LOCATION_DETAIL.DEFAULT}?place=${placeId}`,
    },
    {
      name: 'Địa điểm lân cận',
      isActive: true,
      link: '',
    },
  ];

  React.useEffect(() => {
    if (placeId) {
      actionGetPlaceDetail({
        placeId,
      });
    }

    return () => {
      actionResetPlaceDetail();
    };
  }, [actionGetPlaceDetail, actionResetPlaceDetail, placeId]);

  return (
    <div className={`page-content ${styles.Page}`}>
      <Loading
        loaderOnPage
        loading={
          isLoadingGetSetting
          || isLoadingGetPlaceDetail
        }
      />

      <AppMeta name="VỊ TRÍ" />

      <Container fluid>
        <AppBreadcrumb
          pageTitle="VỊ TRÍ"
          breadcrumbList={breadcrumbList}
        />
        <div className={styles.NearLocationContent}>
          <div className={styles.Header}>
            <h2 className={styles.Title}>Địa điểm nổi tiếng gần chỗ nghỉ</h2>
            <p className={styles.Description}>
              Thêm các điểm tham quan, tiện ích nổi bật ở gần để khách dễ hình dung vị trí,
              thấy thuận tiện khi di chuyển và tin tưởng hơn trước khi đặt.
              Thông tin này cũng giúp chỗ nghỉ hấp dẫn hơn khi hiển thị trong danh sách tìm kiếm.
            </p>
          </div>
          <NearLocationList
            placeId={placeId}
            placeDetail={placeDetail}
            onSaveSuccess={() => actionGetPlaceDetail({ placeId })}
          />
        </div>
      </Container>
    </div>
  );
}

NearLocation.propTypes = {
  isLoadingGetSetting: PropTypes.bool,
  isLoadingGetPlaceDetail: PropTypes.bool,

  placeDetail: PropTypes.instanceOf(Object),

  actionGetPlaceDetail: PropTypes.func,
  actionResetPlaceDetail: PropTypes.func,
};

NearLocation.defaultProps = {
  isLoadingGetSetting: false,
  isLoadingGetPlaceDetail: false,

  placeDetail: INITIAL_VALUE.OBJECT,

  actionGetPlaceDetail: INITIAL_VALUE.FUNCTION,
  actionResetPlaceDetail: INITIAL_VALUE.FUNCTION,
};

export default NearLocation;
